import { useState, useRef, useEffect } from "react";

export default function AdminNavbar() {
    const [open, setOpen] = useState(false);
  const ref = useRef();

  // Tutup dropdown jika klik di luar
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="dropdown" ref={ref} >
      {/* <button
        className="users arrow-down-icon border border-gray-200 rounded-pill p-4 d-inline-block pe-40 position-relative"
        type="button"
        onClick={() => setOpen((v) => !v)}
      >
        <span className="position-relative">
          <img src="admin-template/images/thumbs/user-img.png" className="h-32 w-32 rounded-circle" />
          <span className="activation-badge w-8 h-8 position-absolute inset-block-end-0 inset-inline-end-0"></span>
        </span>
      </button> */}
      {open && (
        <div className="dropdown-menu dropdown-menu--lg border-0 bg-transparent p-0 show" style={{display: "block", right: 0,}}>
          <div className="card border border-gray-100 rounded-12 box-shadow-custom">
            <div className="card-body">
              <div className="flex-align gap-8 mb-20 pb-20 border-bottom border-gray-100">
                <img src="admin-template/images/thumbs/user-img.png" alt="" className="w-54 h-54 rounded-circle" />
                <div>
                  <h4 className="mb-0">Michel John</h4>
                  <p className="fw-medium text-13 text-gray-200">examplemail@mail.com</p>
                </div>
              </div>
              <ul className="max-h-270 overflow-y-auto scroll-sm pe-4">
                {/* ...list menu seperti sebelumnya... */}
                <li className="mb-4">
                  <a href="setting.html" className="py-12 text-15 px-20 hover-bg-gray-50 text-gray-300 rounded-8 flex-align gap-8 fw-medium text-15">
                    <span className="text-2xl text-primary-600 d-flex"><i className="ph ph-gear"></i></span>
                    <span className="text">Account Settings</span>
                  </a>
                </li>
                {/* ...dst... */}
                <li className="pt-8 border-top border-gray-100">
                  <a href="sign-in.html" className="py-12 text-15 px-20 hover-bg-danger-50 text-gray-300 hover-text-danger-600 rounded-8 flex-align gap-8 fw-medium text-15">
                    <span className="text-2xl text-danger-600 d-flex"><i className="ph ph-sign-out"></i></span>
                    <span className="text">Log Out</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}